const isNonEmptyArray = (arr) => {
    return Array.isArray(arr) && arr.length > 0;
};

export { isNonEmptyArray };
//# sourceMappingURL=array-util.js.map
